module.exports = __webpack_public_path__ + "img/SiteIcon.8ab7a680.svg";